import styled from "styled-components";

export const Styledh6 = styled.h6`
    font-weight: ${({ weight = "500" }) => weight};
    font-size: 14px;
    



`;